import type { SessionMetadata } from "../../../../../../../../../shared/types/session.type";
import {
	getVisibleDraftSessions,
	type DraftSession,
} from "../../dialog/utils/draft-sessions-storage";
import { loadSessionInputDrafts } from "../../dialog/utils/setInputDraft";

// updated_at — для отображения даты, order_at — для сортировки/группировки.
// Для сессии с активным черновиком ввода order_at = время черновика.
export type HistoryConversation =
	| {
			kind: "session";
			session: SessionMetadata;
			updated_at: string;
			order_at: string;
	  }
	| {
			kind: "draft";
			draft: DraftSession;
			updated_at: string;
			order_at: string;
	  };

export const buildHistoryConversations = (
	sessions: SessionMetadata[] = [],
): HistoryConversation[] => {
	const inputDraftTimeBySession = new Map(
		loadSessionInputDrafts().map((d) => [d.session_id, d.updated_at]),
	);

	const sessionItems: HistoryConversation[] = sessions
		.filter((s) => !s.is_deleted)
		.map((s) => ({
			kind: "session" as const,
			session: s,
			updated_at: s.updated_at,
			order_at: inputDraftTimeBySession.get(s.session_id) ?? s.updated_at,
		}));

	const draftItems: HistoryConversation[] = getVisibleDraftSessions().map(
		(d) => ({
			kind: "draft" as const,
			draft: d,
			updated_at: d.updated_at,
			order_at: d.updated_at,
		}),
	);

	return [...sessionItems, ...draftItems].sort((a, b) => {
		const da = new Date(a.order_at).getTime();
		const db = new Date(b.order_at).getTime();
		return db - da;
	});
};

export const filterConversationsBySearch = (
	conversations: HistoryConversation[],
	query: string,
): HistoryConversation[] => {
	const q = query.trim().toLowerCase();
	if (!q) return conversations;
	return conversations.filter((item) => {
		if (item.kind === "session") {
			const title = item.session.title
				? String(item.session.title).toLowerCase()
				: "";
			const id = item.session.session_id
				? String(item.session.session_id).toLowerCase()
				: "";
			return title.includes(q) || id.includes(q);
		}
		const title = item.draft.title.toLowerCase();
		const text = item.draft.message_text.toLowerCase();
		return title.includes(q) || text.includes(q);
	});
};
